import React, { useState, useEffect } from "react";
import Enemy from "../components/Enemy";
import Grid from "@mui/material/Grid";
import Search from "../components/Search";
import { LoopCircleLoading } from "react-loadingg";

const EnemiesList = () => {
  const [enemies, setEnemies] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const res = await fetch(
        `https://revived-witch-api.herokuapp.com/api/enemies`
      );
      res.json().then((res) => setEnemies(res.enemies));
    };

    fetchData();
  }, []);

  return (
    <>
      {enemies.length === 0 || null ? (
         <div style={{height: "100vh", weight:"50%"}}><LoopCircleLoading /></div>
      ) : (
        <>
         
          <Grid item xs={12} md={12} style={{ marginBottom: "30px", marginTop : 25 }}>
            <Search data={enemies} />
          </Grid>

          <Grid container spacing={2}>
            {enemies.map((en, index) => (
              <>
                <Grid key={index} item xs={6} md={2} style={{ display: "flex" }}>
                  <Enemy key={en._id} data={en} />
                </Grid>
              </>
            ))}
          </Grid>
        </>
      )}
    </>
  );
};

export default EnemiesList;
